
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 36 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.091 26.85a.374.374 0 00-.3-.593H3.376A.373.373 0 013 25.875V7.125a.375.375 0 01.375-.375h2.25A.375.375 0 016 7.125V7.5a1.5 1.5 0 003 0v-.375a.375.375 0 01.375-.375h2.25a.375.375 0 01.375.375V7.5a1.5 1.5 0 103 0v-.375a.375.375 0 01.375-.375h2.25a.375.375 0 01.375.375V7.5a1.5 1.5 0 103 0v-.375a.375.375 0 01.375-.375h1.5a.375.375 0 01.375.375v12.477a.375.375 0 00.64.265l2.25-2.25c.07-.07.11-.166.11-.265V6.75a3 3 0 00-3-3h-1.875A.373.373 0 0121 3.375V1.5a1.5 1.5 0 10-3 0v1.875a.375.375 0 01-.375.375h-2.25A.373.373 0 0115 3.375V1.5a1.5 1.5 0 10-3 0v1.875a.375.375 0 01-.375.375h-2.25A.374.374 0 019 3.375V1.5a1.5 1.5 0 00-3 0v1.875a.374.374 0 01-.375.375H3a3 3 0 00-3 3v19.5a3 3 0 003 3h12.197a.372.372 0 00.3-.157l1.594-2.243zM34.553 17.387a4.066 4.066 0 00-5.41.409l-9.87 9.87a.374.374 0 000 .531l5.027 5.03a.377.377 0 00.531 0l10.018-10.019a3.933 3.933 0 00-.296-5.821zM18.091 30.197a.374.374 0 00-.631.192l-.944 4.711a.75.75 0 00.886.885l4.714-.944a.374.374 0 00.192-.633l-4.216-4.212z","fill":"currentColor"}})])
          )
        }
      }
    